var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "day-configurator-side-panel", on: { click: _vm.close } },
    [
      _c(
        "div",
        {
          staticClass: "slideout px-16 py-24 p-md-56",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "close", on: { click: _vm.close } }),
          _vm._v(" "),
          _c("h3", { staticClass: "mb-16 mb-md-40" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.translations.request_offer_slideout.title) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row large-gutters mb-32 mb-md-56" }, [
            _c("div", { staticClass: "col-12 col-lg-6 mb-32 mb-lg-0" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center mb-8 mb-md-16"
                },
                [
                  _c("h4", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.translations.request_offer_slideout.summary
                        ) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.firstStep($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.translations.request_offer_slideout.modify)
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column flex-md-row mb-8 mb-md-16" },
                [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.translations.request_offer_slideout.date))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.formattedDate))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column flex-md-row mb-8 mb-md-16" },
                [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(
                      _vm._s(_vm.translations.request_offer_slideout.location)
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.formattedLocation))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-column flex-md-row" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v(
                    _vm._s(_vm.translations.request_offer_slideout.attendees)
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.formattedAttendees))
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-lg-6" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex  justify-content-between align-items-center mb-8 mb-md-16"
                  },
                  [
                    _c("h4", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.translations.request_offer_slideout.schedule
                          ) +
                          "\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.$emit("previous-step")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.translations.request_offer_slideout.modify)
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.sortedActivities, function(activity, index) {
                  return _c(
                    "div",
                    {
                      key: "" + index + activity.start,
                      staticClass:
                        "d-flex flex-column flex-md-row mb-8 mb-md-16"
                    },
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.activityStartEndString(activity)))
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "value",
                        domProps: {
                          innerHTML: _vm._s(_vm.activityNameString(activity))
                        }
                      })
                    ]
                  )
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "mb-16" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.translations.request_offer_slideout.contact_info) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("ValidationObserver", {
            ref: "observer",
            attrs: { tag: "div", slim: true },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var invalid = ref.invalid
                  return [
                    _c("div", { staticClass: "row large-gutters mb-32" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-6" },
                        [
                          _c("el-input", {
                            staticClass: "mb-24",
                            attrs: {
                              type: "text",
                              label:
                                _vm.translations.request_offer_slideout
                                  .first_name,
                              rules: "required"
                            },
                            model: {
                              value: _vm.formData.first_name,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "first_name", $$v)
                              },
                              expression: "formData.first_name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-6" },
                        [
                          _c("el-input", {
                            staticClass: "mb-24",
                            attrs: {
                              type: "text",
                              label:
                                _vm.translations.request_offer_slideout
                                  .last_name,
                              rules: "required"
                            },
                            model: {
                              value: _vm.formData.last_name,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "last_name", $$v)
                              },
                              expression: "formData.last_name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-6" },
                        [
                          _c("el-input", {
                            staticClass: "mb-24",
                            attrs: {
                              type: "email",
                              label:
                                _vm.translations.request_offer_slideout.email,
                              rules: "required|email"
                            },
                            model: {
                              value: _vm.formData.email,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "email", $$v)
                              },
                              expression: "formData.email"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-6" },
                        [
                          _c("el-input", {
                            staticClass: "mb-24",
                            attrs: {
                              type: "text",
                              label:
                                _vm.translations.request_offer_slideout.phone,
                              rules: "required"
                            },
                            model: {
                              value: _vm.formData.phone,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "phone", $$v)
                              },
                              expression: "formData.phone"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-6" },
                        [
                          _c("el-input", {
                            staticClass: "mb-24",
                            attrs: {
                              type: "text",
                              label:
                                _vm.translations.request_offer_slideout
                                  .vat_number,
                              rules: "required"
                            },
                            model: {
                              value: _vm.formData.vat,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "vat", $$v)
                              },
                              expression: "formData.vat"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-6" },
                        [
                          _c("el-input", {
                            staticClass: "mb-24",
                            attrs: {
                              type: "text",
                              label:
                                _vm.translations.request_offer_slideout.company,
                              rules: "required"
                            },
                            model: {
                              value: _vm.formData.company,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "company", $$v)
                              },
                              expression: "formData.company"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-8" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.translations.request_offer_slideout.remarks
                          ) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-24 font-weight-light" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.translations.request_offer_slideout
                              .remarks_description
                          ) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        label: _vm.translations.request_offer_slideout.message,
                        rules: ""
                      },
                      model: {
                        value: _vm.formData.remarks,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "remarks", $$v)
                        },
                        expression: "formData.remarks"
                      }
                    }),
                    _vm._v(" "),
                    _c("hr", { staticClass: "mx-n56 mt-56 mb-24" }),
                    _vm._v(" "),
                    _c("el-button", {
                      class: "btn btn-accent text-white",
                      attrs: {
                        loading: _vm.loading,
                        success: _vm.success,
                        loadingLabel:
                          _vm.translations.request_offer_slideout.button,
                        successLabel:
                          _vm.translations.request_offer_slideout.button,
                        defaultLabel:
                          _vm.translations.request_offer_slideout.button,
                        disabled: invalid || _vm.success
                      },
                      on: { click: _vm.submit }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("success-popover", {
        class: { active: _vm.success },
        attrs: {
          title: _vm.translations.request_offer_slideout.success_title,
          description:
            _vm.translations.request_offer_slideout.success_description,
          cta: _vm.translations.request_offer_slideout.success_cta
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }